import { render, staticRenderFns } from "./DropdownOptionsExportarRelatorio.vue?vue&type=template&id=1dcf30dd&scoped=true"
import script from "./DropdownOptionsExportarRelatorio.vue?vue&type=script&lang=js"
export * from "./DropdownOptionsExportarRelatorio.vue?vue&type=script&lang=js"
import style0 from "./DropdownOptionsExportarRelatorio.vue?vue&type=style&index=0&id=1dcf30dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf30dd",
  null
  
)

export default component.exports